import triot from 'triot';
import defineComponent from 'flight';

function TriotFlightBridge() {
    let evtNames = {
        TRIOT_TEARDOWN: 'triot:teardown',
        FLIGHT_TEARDOWN: 'ui:teardown',
        GA_TRACK: 'analytics:track-event',
        PJAX_NAVIGATE: 'ui:navigate'
    };

    this._teardownTriot = function() {
        triot.bus.trigger(evtNames.TRIOT_TEARDOWN, { keepRootTag: true });
    };

    this._gaEvent = function(payload) {
        this.trigger(document, evtNames.GA_TRACK, payload);
    };

    this._navigate = function(payload) {
        this.trigger(document, evtNames.PJAX_NAVIGATE, payload);
    };

    this.after('initialize', function() {
        // Flight events
        this.on(evtNames.FLIGHT_TEARDOWN, this._teardownTriot);

        // Triot events
        triot.bus.on(evtNames.GA_TRACK, this._gaEvent.bind(this));
        triot.bus.on(evtNames.PJAX_NAVIGATE, this._navigate.bind(this));
    });
}

export default defineComponent.component(TriotFlightBridge);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/triot-flight-bridge.js